/**
 * Constantes des événements PostHog
 * Centralisation pour cohérence avec le backend
 */

export const PostHogEvents = {
  // Authentification
  SIGNUP_COMPLETED: 'signup_completed',
  LOGIN_SUCCESSFUL: 'login_successful',
  EMAIL_VERIFIED: 'email_verified',

  // Onboarding
  SIRET_SUBMITTED: 'siret_submitted',
  ORG_SEARCH_RESULT: 'org_search_result',
  FORMATIONS_LOADED: 'formations_loaded',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  ACCESS_REQUEST_SENT: 'access_request_sent',
  ORGANIZATION_LINKED: 'organization_linked',

  // Freemium
  FREEMIUM_LIMIT_REACHED: 'freemium_limit_reached',
  ANALYSIS_BLOCKED: 'analysis_blocked_freemium',
  PROJECT_LIMIT_REACHED: 'project_limit_reached',

  // Analyse & Fusion
  ANALYSIS_REQUESTED: 'analysis_requested',
  ANALYSIS_COMPLETED: 'analysis_completed',
  FUSION_SUGGESTION_SHOWN: 'fusion_suggestion_shown',
  FUSION_ACCEPTED: 'fusion_accepted',

  // Conversion
  UPGRADE_CLICKED: 'upgrade_clicked',
  PRICING_PAGE_VIEWED: 'pricing_page_viewed',
  CHECKOUT_STARTED: 'checkout_started',
  PURCHASE_COMPLETED: 'purchase_completed',

  // Utilisation
  VISUALIZATION_VIEWED: 'visualization_viewed',
  PROJECT_CREATED: 'project_created',
  RNCP_SEARCHED: 'rncp_searched',

  // Consentement
  ANALYTICS_CONSENT_GIVEN: 'analytics_consent_given',
  ANALYTICS_CONSENT_REVOKED: 'analytics_consent_revoked'
};
